import styled from 'styled-components';

export const StyledCodeBlock = styled.pre`
  color: ${(props) => props.theme.globalColors.light};
  line-height: 1.75rem;
`;
